import axios from '@projectK/services/axios';

const jwtAxios = axios?.create({
  // eslint-disable-next-line no-restricted-globals
  baseURL:
    location.host === 'localhost:4200' ? `http://localhost:5000/api` : '/api', //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});
const excludedRoutes = [
   '/signin',
  '/signup',
  '/reset-password',
  '/invitation',
  '/widgets/products',
  '/widgets/packages',
  '/terms-conditions',
  '/privacy-policy'
];

jwtAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    const currentPath = window.location.pathname;

    if (err.response && err.response.status === 401) {
      // Check if route starts with any excluded route
      const isExcluded = excludedRoutes.some(route =>
        currentPath.startsWith(route)
      );

      if (!isExcluded) {
        window.location.href = '/signin';
      }
    }

    return Promise.reject(err);
  },
);
export const setAuthToken = (token) => {
  if (token) {
    jwtAxios.defaults.headers.common['Authorization'] = token;

    localStorage.setItem('token', token);
  } else {
    delete jwtAxios.defaults.headers.common['Authorization'];
    localStorage.removeItem('token');
  }
};

export default jwtAxios;
